import { localisation } from '@/constants/ru-text';
import type { Message } from '@/composables/toast';

export const STORAGE_KEY = 'warning-toast-shown';

const t = localisation('toast-trouble-video');

export const DEFAULT_MESSAGE: Message = {
  title: t('title') ?? 'Ограничения обработки видео',
  description:
    t('description') ??
    'По техническим причинам загрузка и обработка видео может быть временно недоступна.',
};
